type ToggleSelectedFieldOptions = {
  requiredFields?: string[];
  minRequired?: number;
};

export const toggleSelectedField = (
  prev: string[],
  field: string,
  options: ToggleSelectedFieldOptions = {}
): string[] => {
  const requiredFields = new Set(options.requiredFields ?? []);
  const minRequired = options.minRequired ?? 1;

  if (prev.includes(field)) {
    if (requiredFields.has(field)) {
      const selectedRequiredCount = prev.filter(item =>
        requiredFields.has(item)
      ).length;
      if (selectedRequiredCount <= minRequired) {
        return prev;
      }
    }
    return prev.filter(item => item !== field);
  }

  return [...prev, field];
};
